export default [
    {
        path: '/platinum/page/:id/device-preview',
        props: false,
        component: () => import('@/views/PlatinumPage/Preview'),
    },
];
